import { System } from '@leverege/api-redux';
import { GlobalState } from '@leverege/ui-redux';
export default class ResourceEnumAttributeValueSuggestor {
  constructor(type, opts = {}) {
    this.attribute = opts.attribute;
    this.delegate = opts.delegate;
    this.relationship = opts.relationship;
    this.objectType = opts.objectType;
  }
  async suggest(value) {
    const resourceEnumType = this.attribute?.blueprint?.attribute?.model?.enumType;
    const enumData = System(this.relationship.systemId).resourceEnum(resourceEnumType).getResourceEnum(GlobalState.get());
    return enumData?.values || [];
  }
}